import * as types from './actionTypes';
import * as searchApi from '../../api/searchApi';
import * as participatingResourcesApi from '../../api/participatingResourcesApi';

export function loadSearchFiltersSuccess(resourcesList) {
  return { type: types.LOAD_RESOURCES_LIST_SUCCESS, resourcesList };
}

export function loadSearchResultsSuccess(searchResults) {
  return { type: types.LOAD_SEARCH_RESULTS_SUCCESS, searchResults };
}

export function runFullTextSearch(searchText) {
  return { type: types.RUN_FULL_TEXT_SEARCH, searchText };
}

export function applyResourcesFilter(filter) {
  return { type: types.UPDATE_RESOURCES_FILTER_SUCCESS, filter };
}

export function handleBubbleSearchTextRemove() {
  return { type: types.RUN_FULL_TEXT_SEARCH, searchText: '' };
}

export function handleBubbleResourcesRemove() {
  return { type: types.UPDATE_RESOURCES_FILTER_SUCCESS, filter: [] };
}

export function switchSorting(sorting) {
  return { type: types.SWITCH_SORTING, sorting };
}

export function switchSortingOrder(order) {
  return { type: types.SWITCH_SORTING_ORDER, order };
}

export function switchPage(pageInfo) {
  return { type: types.SWITCH_PAGE, pageInfo };
}

export function switchSize(pageInfo) {
  return { type: types.SWITCH_SIZE, pageInfo };
}

export function loadSearchDataResources() {
  const func = function func(dispatch) {
    return participatingResourcesApi.getAllParticipatingResources()
      .then((response) => {
        const resourcesList = {
          primary_disease: response.data.primary_disease || [],
          dataset_source_repo: response.data.dataset_source_repo || [],
        };
        dispatch(loadSearchFiltersSuccess(resourcesList));
      })
      .catch((error) => {
        throw error;
      });
  };
  return func;
}

export function loadFromUrlQuery(searchText, filters) {
  const func = function func(dispatch) {
    const searchCriteria = {};
    searchCriteria.search_text = searchText;
    searchCriteria.filters = {};

    if (Array.isArray(filters.filterByResource) && filters.filterByResource.length > 0) {
      searchCriteria.filters.primary_disease = filters.filterByResource;
    }

    if (Array.isArray(filters.filterByRepo) && filters.filterByRepo.length > 0) {
      searchCriteria.filters.dataset_source_repo = filters.filterByRepo;
    }

    searchCriteria.pageInfo = {};
    searchCriteria.pageInfo.page = filters.page ? filters.page : 1;
    searchCriteria.pageInfo.pageSize = filters.pageSize ? filters.pageSize : 10;

    searchCriteria.sort = {};
    searchCriteria.sort.name = 'Dataset';
    searchCriteria.sort.k = 'dataset_title_sort';
    searchCriteria.sort.v = filters.sortOrder || 'asc';

    // Call both searchCatalog and getSearchFilters in parallel
    // For filters endpoint, include only search_text and filters in the body
    const filtersBody = {
      search_text: searchCriteria.search_text,
      filters: searchCriteria.filters,
    };
    return Promise.all([
      searchApi.searchDatasets(searchCriteria),
      searchApi.getSearchFilters(filtersBody),
    ])
      .then(([searchResults, filtersResults]) => {
        dispatch(loadSearchResultsSuccess(searchResults.data));
        dispatch(runFullTextSearch(searchText));
        dispatch(applyResourcesFilter(searchCriteria.filters));
        dispatch(switchPage(searchResults.data.pageInfo));
        dispatch(switchSize(searchResults.data.pageInfo));
        dispatch(switchSorting({
          name: searchResults.data.sort.name,
          k: searchResults.data.sort.k,
        }));
        dispatch(switchSortingOrder(searchResults.data.sort.v));
        // Optionally update filters in state if needed
        if (filtersResults && filtersResults.data) {
          dispatch(loadSearchFiltersSuccess(filtersResults.data));
        }
      })
      .catch((error) => {
        throw error;
      });
  };
  return func;
}

export function startFullTextSearch(searchText) {
  const func = function func(dispatch) {
    dispatch(runFullTextSearch(searchText));
  };
  return func;
}

export function bubbleSearchTextRemoveClick() {
  const func = function func(dispatch) {
    dispatch(handleBubbleSearchTextRemove());
  };
  return func;
}

export function bubbleResourcesRemoveClick() {
  const func = function func(dispatch) {
    dispatch(handleBubbleResourcesRemove());
  };
  return func;
}

export function changeSorting(sorting) {
  const func = function func(dispatch) {
    dispatch(switchSorting(sorting));
  };
  return func;
}

export function changeSortingOrder(order) {
  const func = function func(dispatch) {
    dispatch(switchSortingOrder(order));
  };
  return func;
}

export function pageSelect(pageInfo) {
  const func = function func(dispatch) {
    dispatch(switchPage(pageInfo));
  };
  return func;
}

export function sizeSelect(pageInfo) {
  const func = function func(dispatch) {
    dispatch(switchSize({ pageSize: pageInfo.pageSize ? pageInfo.pageSize : 10 }));
  };
  return func;
}
